module.exports = __webpack_public_path__ + "img/icon-gas-oven-stove.7e1b0093.svg";